// extracted by mini-css-extract-plugin
module.exports = {"popup":"_LegacyPopUp_popup__3iFZX"};